import React from 'react';

import { EDIT_PROFILE_URL } from 'global-constants';
import WithPush from 'shared/HOCs/WithPush';

import styles from './styles.module.scss';

const ProgressBar = ({ percentage, title, push }) => {
  return (
    <div
      className={styles.progressbarWrapper}
      onClick={() => push(EDIT_PROFILE_URL)}>
      <div className={styles.label}>
        {title}
        <span className={styles.percentage}>{percentage}%</span>
      </div>
      <div className={styles.progressbarContainer}>
        <div
          className={styles.progress}
          style={{
            width: `${percentage}%`,
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px'
          }}
        />
      </div>
    </div>
  );
};

export default WithPush(ProgressBar);
